import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Seo } from "../components/Layout";
import { SITE } from "../lib/site";

export default function Rgpd() {
  useEffect(() => { document.title = "Politique de confidentialité | Parfaits Imparfaits"; }, []);
  return (
    <>
      <Seo title="Politique de confidentialité" description="Politique de confidentialité et de protection des données personnelles du site parfaitsimparfaits.fr." canonical="https://www.parfaitsimparfaits.fr/politique-de-confidentialite" />
      <section className="pt-40 pb-12" data-testid="rgpd-hero">
        <div className="max-w-3xl mx-auto px-6 lg:px-10">
          <p className="eyebrow mb-5">Vie privée</p>
          <h1 className="text-5xl font-serif font-light text-sand-900">Politique de confidentialité</h1>
          <p className="mt-6 text-sand-700">
            La protection de votre vie privée est essentielle. Cette page décrit, en
            toute transparence, les données que je collecte, pourquoi, comment elles
            sont protégées et les droits dont vous disposez.
          </p>
        </div>
      </section>

      <section className="pb-32" data-testid="rgpd-content">
        <div className="max-w-3xl mx-auto px-6 lg:px-10 prose-mystic text-base">

          <h2 className="text-2xl font-serif text-sand-900">1. Responsable du traitement</h2>
          <p>
            Le responsable du traitement des données est <strong>{SITE.legal.director}</strong>,
            éditrice du site <strong>parfaitsimparfaits.fr</strong>, joignable à l'adresse&nbsp;
            <a href={`mailto:${SITE.email}`} className="text-sand-500">{SITE.email}</a>.
          </p>

          <h2 className="text-2xl font-serif text-sand-900">2. Données collectées</h2>
          <p>
            Aucune donnée personnelle n'est collectée à votre insu. Les informations
            recueillies via ce site le sont uniquement lorsque vous me sollicitez
            volontairement, notamment :
          </p>
          <ul className="list-disc pl-6 space-y-1 text-sand-700">
            <li><strong>Formulaire de contact</strong> : nom, adresse e-mail, téléphone (facultatif), message.</li>
            <li><strong>Prise de rendez-vous</strong> : informations nécessaires à la planification d'une séance.</li>
          </ul>

          <h2 className="text-2xl font-serif text-sand-900">3. Finalités du traitement</h2>
          <p>Vos données sont traitées exclusivement pour :</p>
          <ul className="list-disc pl-6 space-y-1 text-sand-700">
            <li>Répondre à votre demande de contact ou de rendez-vous ;</li>
            <li>Assurer le suivi de votre accompagnement le cas échéant ;</li>
            <li>Respecter les obligations légales et comptables.</li>
          </ul>
          <p>
            Aucune donnée n'est cédée, vendue ou louée à des tiers à des fins commerciales.
          </p>

          <h2 className="text-2xl font-serif text-sand-900">4. Base légale</h2>
          <p>
            Le traitement repose sur votre <strong>consentement</strong> (envoi du formulaire) et,
            le cas échéant, sur l'<strong>exécution d'un contrat</strong> (séance réservée) ainsi
            que sur les <strong>obligations légales</strong> applicables aux professionnels.
          </p>

          <h2 className="text-2xl font-serif text-sand-900">5. Durée de conservation</h2>
          <ul className="list-disc pl-6 space-y-1 text-sand-700">
            <li>Messages via le formulaire de contact : jusqu'à 3 ans après le dernier échange.</li>
            <li>Informations liées à un suivi : durée légale de conservation des documents professionnels.</li>
          </ul>

          <h2 className="text-2xl font-serif text-sand-900">6. Destinataires des données</h2>
          <p>
            Seule Valentine DL accède à vos données. Le site et ses prestataires techniques
            (hébergeur, service d'envoi d'e-mails) interviennent dans le strict cadre
            d'un contrat de sous-traitance conforme au RGPD.
          </p>

          <h2 className="text-2xl font-serif text-sand-900">7. Sécurité</h2>
          <p>
            Vos données sont stockées sur des serveurs sécurisés. Les échanges entre votre
            navigateur et ce site sont chiffrés (HTTPS). L'accès administrateur au site
            est protégé par une authentification forte.
          </p>

          <h2 className="text-2xl font-serif text-sand-900">8. Cookies</h2>
          <p>
            Ce site n'utilise pas de cookies publicitaires ni de traceurs marketing.
            Seuls des cookies strictement nécessaires au fonctionnement du site
            (par exemple, la session d'administration) peuvent être déposés.
          </p>

          <h2 className="text-2xl font-serif text-sand-900">9. Vos droits</h2>
          <p>Conformément au RGPD et à la loi Informatique et Libertés, vous disposez :</p>
          <ul className="list-disc pl-6 space-y-1 text-sand-700">
            <li>D'un droit d'<strong>accès</strong> à vos données ;</li>
            <li>D'un droit de <strong>rectification</strong> et de <strong>mise à jour</strong> ;</li>
            <li>D'un droit à l'<strong>effacement</strong> (« droit à l'oubli ») ;</li>
            <li>D'un droit à la <strong>limitation</strong> du traitement ;</li>
            <li>D'un droit à la <strong>portabilité</strong> des données ;</li>
            <li>D'un droit d'<strong>opposition</strong> au traitement ;</li>
            <li>Du droit de retirer votre <strong>consentement</strong> à tout moment.</li>
          </ul>
          <p>
            Pour exercer ces droits, écrivez-moi à&nbsp;
            <a href={`mailto:${SITE.email}`} className="text-sand-500">{SITE.email}</a>.
            Une réponse vous sera apportée sous un mois.
          </p>

          <h2 className="text-2xl font-serif text-sand-900">10. Réclamation</h2>
          <p>
            Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire
            une réclamation auprès de la <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-sand-500 underline">CNIL</a>
            &nbsp;(Commission nationale de l'informatique et des libertés).
          </p>

          <h2 className="text-2xl font-serif text-sand-900">11. Mise à jour</h2>
          <p>
            La présente politique peut être mise à jour à tout moment. La date de
            dernière modification figure ci-dessous.
          </p>
          <p className="text-sm text-sand-500">Dernière mise à jour : {new Date().toLocaleDateString("fr-FR", { year: "numeric", month: "long" })}.</p>

          <p className="mt-10">
            Consultez aussi nos <Link to="/mentions-legales" className="text-sand-500 underline">mentions légales</Link>.
          </p>
        </div>
      </section>
    </>
  );
}
